export default __webpack_public_path__ + "static/media/5.c4664d65.svg";